import request from '@/utils/request'
import { getToken } from '../utils/auth'
// 查询计生法律信息统计
export function querylaweralarminfo (params, data) {
  params.token = getToken()
  return request({
    url: '/querylaweralarminfo',
    method: 'post',
    params,
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/otherStatistics.js